function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("polygon", {
  points: "12 15.5857864 21.2928932 6.29289322 22.7071068 7.70710678 12 18.4142136 1.29289322 7.70710678 2.70710678 6.29289322"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/dropdown.0baba419.svg";
export { SvgComponent as ReactComponent };